import React, { useEffect, useState } from 'react';
import { getMyCropsLast } from '../../services/mycrops/myCropsService';
import MyCropCard from './MyCropCard';
import LoadingComponent from '../loading/LoadingComponent';

const MyCropsView = () => {
    const [crops, setCrops] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const backgroundImage = "url('/assets/images/backgrounds/Sensors.jpg')";

    useEffect(() => {
        const fetchCrops = async () => {
            try {
                const data = await getMyCropsLast();
                setCrops(data);
                setLoading(false);
            } catch (err) {
                console.error("Failed to fetch crops", err);
                setError(true);
                setLoading(false);
            }
        };

        fetchCrops();
    }, []);

    if (loading) {
        return <LoadingComponent />;
    }

    if (error) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="text-center p-8 bg-white rounded-xl shadow-lg">
                    <span className="material-icons text-red-500 text-5xl mb-4">error_outline</span>
                    <h2 className="text-xl font-bold text-gray-800 mb-2">Error al cargar cultivos</h2>
                    <p className="text-gray-600">No pudimos cargar la información de tus cultivos. Por favor intenta nuevamente.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-full flex flex-col">
            <div className="flex-1 min-h-screen bg-cover bg-center bg-fixed" style={{ backgroundImage: backgroundImage }}>
                <div className="bg-black/30 min-h-screen w-full p-6">
                    <div className="max-w-7xl mx-auto">
                        <div className="flex items-center justify-between mb-8">
                            <div>
                                <h1 className="text-3xl font-bold text-white shadow-sm">Mis Cultivos</h1>
                                <p className="text-gray-200 mt-1">Gesti&oacute;n y seguimiento fenol&oacute;gico</p>
                            </div>
                        </div>

                        {crops.length === 0 ? (
                            <div className="bg-white/90 backdrop-blur rounded-xl p-8 text-center max-w-lg mx-auto mt-10">
                                <span className="material-icons text-gray-400 text-6xl mb-4">grass</span>
                                <h3 className="text-xl font-semibold text-gray-800">No tienes cultivos asociados</h3>
                                <p className="text-gray-500 mt-2">Parece que no tienes sensores asignados a cultivos todav&iacute;a.</p>
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                                {crops.map((crop) => (
                                    <MyCropCard key={crop.id} crop={crop} />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyCropsView;
